import { Icon } from 'src/components-v2/DataDisplay/Icon';
import { Btn } from 'src/components-v2/Inputs';
import { targetMap } from 'src/lib/constants';
import { useVideoGate } from 'src/sections/EmbeddedVideoCard/CmsEmbeddedVideoCard/VideoGate';
import { useEmbeddedVideoCard } from 'src/sections/EmbeddedVideoCard/CmsEmbeddedVideoCard/VideoCard';
import {
  IBtnProps,
  IBtnWithHref,
  IBtnWithClick,
} from 'src/components-v2/Inputs/Button/Btn.types';

const makeClickHandler = ({
  fields,
  isModalOpen,
  setIsModalOpen,
  setIsVideoPlaying,
  requestPlayback,
}) => {
  const action: Partial<IBtnProps> = {};
  if (fields?.target === 'Video') {
    action.onClick = () => {
      const start = () => {
        setIsVideoPlaying(true);
      };
      if (requestPlayback) {
        requestPlayback(start);
        return;
      }
      start();
    };
  } else if (fields?.target === 'Modal') {
    action.onClick = () => {
      return null; // SITE-5615 removed gold cast modal method
    };
  } else {
    action.href = fields?.url;
    action.target = targetMap[fields?.target];
  }
  return action as IBtnWithClick | IBtnWithHref;
};

export const EmbeddedEntryButton = ({ fields, node, sx = {} }) => {
  const { setIsVideoPlaying } = useEmbeddedVideoCard();
  const gate = useVideoGate();

  // we add a icon spacer to the button to ensure the text is centered when an icon is present
  const hasIcon =
    fields?.leftIcon?.fields?.icon || fields?.rightIcon?.fields?.icon;
  const iconSpacer = hasIcon ? <span /> : null;

  // we need to make sure we're using the correct button type based on the button target
  // this will handle opening a modal or playing a video
  const action = makeClickHandler({
    fields,
    isModalOpen: false,
    setIsModalOpen: () => {
      return null; // SITE-5615 removed gold cast modal method
    },
    setIsVideoPlaying,
    requestPlayback: gate?.requestPlayback,
  });

  return (
    <Btn
      className='btn'
      variant={fields?.appearance?.toLowerCase()}
      trackingId={fields?.trackingId || ''}
      sys={node?.data?.target?.sys}
      sx={sx}
      leftIcon={
        fields?.leftIcon?.fields?.icon ? (
          <Icon
            className='btn-icon'
            icon={fields?.leftIcon?.fields?.icon}
            size={20}
          />
        ) : (
          iconSpacer
        )
      }
      rightIcon={
        fields?.rightIcon?.fields?.icon ? (
          <Icon
            className='btn-icon'
            icon={fields?.rightIcon?.fields?.icon}
            size={20}
          />
        ) : (
          iconSpacer
        )
      }
      {...action}
    >
      {fields?.text}
    </Btn>
  );
};
